/* eslint-disable jsx-a11y/click-events-have-key-events */
const React = require('react');
const { arrayOf, shape, string } = require('prop-types');
const { CarouselSnapped } = require('@andes/carousel-snapped');

const { CarouselSnappedSlide } = CarouselSnapped;

const { buildSelectorsUrl } = require('@pages/V2/utils/clientUtils');
const { getTranslationsBySite } = require('@pages/V2/translations');

const { Image } = require('nordic/image');

const SelectorsMenu = ({ selectors, actualLocation, siteId, showSelectorsMenu = true }) => {
  const translations = getTranslationsBySite(siteId);
  const { title, subtitle } = translations.selectorsMenu;

  const applySelector = ({ filterApplied, filterPosition, recommendedDomain }) => {
    const url = buildSelectorsUrl({ actualLocation, filterApplied, filterPosition, recommendedDomain });
    if (typeof document !== 'undefined') document.location.href = url;
  };

  return (
    <div className="selectors_header_container">
      <section className="selectors_carousel">
        <a className="selectors_carousel--link">
          <div className="carousel_header">
            <h1 className="header_title">{title}</h1>
            <span className="header_subtitle">{subtitle}</span>
          </div>
        </a>
        <div className="carousel_ul animate" style={{ opacity: 1 }}>
          {showSelectorsMenu && (
            <CarouselSnapped spacing={0} pagination={false} speed={250} slidesPerView={6} srLabel="selectors">
              {selectors?.map(({ name, filter, image_src, isSlideSelected, recommended_domain }, index) => (
                <CarouselSnappedSlide key={name}>
                  <div
                    role="button"
                    tabIndex={0}
                    className={`carousel_item ${isSlideSelected ? 'selected' : ''}`}
                    onClick={() =>
                      applySelector({
                        filterApplied: filter,
                        filterPosition: index,
                        recommendedDomain: recommended_domain,
                      })
                    }
                  >
                    <Image
                      className="image"
                      src={image_src}
                      lazyload={index < 6 ? 'off' : 'on'}
                      width="48px"
                      alt=""
                      height="48px"
                    />
                    {name && <p className="title" dangerouslySetInnerHTML={{ __html: name }}></p>}
                  </div>
                </CarouselSnappedSlide>
              ))}
            </CarouselSnapped>
          )}
        </div>
      </section>
    </div>
  );
};

SelectorsMenu.propTypes = {
  selectors: arrayOf(shape({ name: string, filter: shape({}), image_src: string })).isRequired,
  actualLocation: string.isRequired,
  siteId: string.isRequired,
};

module.exports = SelectorsMenu;
